<template>
  <div>
    <modal class="confirmation-modal" width="460px"   :value="showModal" effect="fade" @closed="closed"  :backdrop="false" >
      <!-- custom header -->
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          <strong>{{textTitle}}</strong>
        </h4>
      </div>
      <div  class="modal-body confirmation-modal-body " style="height: 80px;padding: 5px 15px; overflow-x: auto;" >
          <span v-html="textMessage"></span>
          <br>
          <br>
          <center>
            <span
            style="font-size: 30px;color: #5b9bd5;"
            class="glyphicon glyphicon-repeat glyphicon-spin"
          ></span>
          </center>
      </div>
      <div slot="modal-footer" class="modal-footer" style="background:white">
        <!-- <button type="button" class="btn btn-default " @click="closed('no')">{{textNo}}</button>
        <button type="button" class="btn btn-primary " @click="closed('yes')">{{textYes}}</button> -->
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import { bus } from "@/libs/bus";
import { utils } from "@/libs/utils";
var vm = this;

import  modal  from "./local-modal";
Vue.component("modal", modal);

import debug from "debug";
var debug_msg = debug("esma:confirmation-modal2");

export default {
  data() {
    return {
      show_modal: false,

      title_label: "",
      message: "",
      // yes_label: "",
      // no_label: "",
      callback:null
    };
  },
  computed: {
      getTrue(){
          return true;
      },
      getFalse(){
          return false;
      },
    textTitle() {
      return this.title_label;
    },
    textMessage() {
      return this.message;
    },
    // textYes() {
    //   return this.yes_label;
    // },
    // textNo() {
    //   return this.no_label;
    // },
    showModal:{
      get(){
        return this.show_modal;
      },
      set(v){
        this.show_modal = v;
      }
    },
  },
  methods: {
    showModalWindow(data) {
        debug_msg("data",data)
      this.title_label = data.title;
      this.message = data.message;
      // this.yes_label = data.yes_label;
      // this.no_label = data.no_label;
      this.showModal = true;
    },
    hideModalWindow(){
      this.showModal = false;
    },
    closed(mode) {
        console.log("mode",mode)
        this.showModal = false;
        // this.$emit('done',mode);
    }
  },
  props: {
    tag: { type: String, default: "showProgressModal" },
    hide_tag: { type: String, default: "hideProgressModal" }
  },
  mounted() {
    bus.$on(this.$props.tag, this.showModalWindow);
    bus.$on(this.$props.hide_tag, this.hideModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
    bus.$off(this.$props.hide_tag);
  }
};
</script>
<style scoped>




.info_div {
  width: 32%;
  float: left;
}
.esma_td2 {
  margin: 2px 0px;
  border: 0px solid #bdbdbd;

  font-size: 11px;
  font-weight: 500;
  padding: 4px 0px 4px 4px;
}

.esma_td_h2 {
  margin: 2px 0px;
  _border: 1px solid #bdbdbd;
  _background-color: #b4d5f1;
  padding: 4px 8px;
  font-size: 11px;
  _font-weight: 900;
  
}
.fa-spin-custom, .glyphicon-spin {
    -webkit-animation: spin 1500ms infinite linear;
    animation: spin 1500ms infinite linear;
}
</style>



// WEBPACK FOOTER //
// progress-modal.vue?656bc468